"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyImportInterfaces = exports.createImportInterfaces = void 0;
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var AutoModuleHelpers_1 = require("../autoModule/AutoModuleHelpers");
var InterruptActions_1 = require("../interrupts/InterruptActions");
var Utils_1 = require("../Utils");
var createImportInterfaces = function (imports, model, config) {
    return new MyImportInterfaces(imports, model, config);
};
exports.createImportInterfaces = createImportInterfaces;
var MyImportInterfaces = /** @class */ (function () {
    function MyImportInterfaces(imports, model, config) {
        var _this = this;
        this.createProcessedImports = function (stage) {
            var _a;
            var processedImports = _this.filterImports();
            (_a = (0, Utils_1.getKeys)(processedImports !== null && processedImports !== void 0 ? processedImports : {})) === null || _a === void 0 ? void 0 : _a.forEach(function (key) {
                var _a;
                var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                processedImports = __assign(__assign({}, processedImports), (_a = {}, _a[key] = __assign(__assign(__assign({}, processedImports[key]), { args: stage === "arguments"
                        ? (_b = _this.model) === null || _b === void 0 ? void 0 : _b.getDerivedFunction(key + "_args")
                        : (_c = processedImports[key]) === null || _c === void 0 ? void 0 : _c.args, results: stage === "results"
                        ? _this.getResults(processedImports, key)
                        : (_d = processedImports[key]) === null || _d === void 0 ? void 0 : _d.results, name: (_e = _this.model.getDerivedFunction("importName", key)) !== null && _e !== void 0 ? _e : (_f = processedImports[key]) === null || _f === void 0 ? void 0 : _f.name, handle: (0, AutoModuleHelpers_1.getProcessedHandle)(processedImports[key].handle, processedImports[key].payload), options: (_j = _this.getProcessedImportOptions(key, (_h = (_g = processedImports[key]) === null || _g === void 0 ? void 0 : _g.options) !== null && _h !== void 0 ? _h : [])) !== null && _j !== void 0 ? _j : processedImports[key].options }), (_l = (_k = _this.model
                    .getDerivedFunctions()).overrideImport) === null || _l === void 0 ? void 0 : _l.call(_k, key, processedImports[key])), _a));
            });
            return processedImports;
        };
        this.filterImports = function () {
            var _a, _b, _c;
            var filteredImports = (_c = (_b = (_a = _this.model.getDerivedFunctions()).filterImports) === null || _b === void 0 ? void 0 : _b.call(_a, _this.imports)) !== null && _c !== void 0 ? _c : _this.imports;
            return filteredImports;
        };
        //Populates option labels with a custom module name if provided in export payload
        this.getProcessedImportOptions = function (importKey, options) {
            var modifiedOptions = [];
            options === null || options === void 0 ? void 0 : options.forEach(function (option, index) {
                var _a, _b;
                modifiedOptions[index] = __assign(__assign({}, option), { handle: __assign(__assign({}, option.handle), { label: (_a = _this.model.getDerivedFunction("importOptionLabel", importKey, option)) !== null && _a !== void 0 ? _a : (_b = option.payload) === null || _b === void 0 ? void 0 : _b.moduleName }) });
            });
            return modifiedOptions;
        };
        this.getResults = function (imports, key) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
            var importResults = (_a = _this.model) === null || _a === void 0 ? void 0 : _a.getDerivedFunction(key + "_results");
            if (importResults)
                return importResults;
            var imp = imports[key];
            if (imp.interfaceId.name === "initializer-system") {
                var initResults = {
                    initializer: {
                        name: _this.model.getName() + "_Initialize",
                        header: (_c = (_b = _this.model) === null || _b === void 0 ? void 0 : _b.getDerivedFunction("headerFile")) !== null && _c !== void 0 ? _c : {
                            name: _this.model.getName().toLowerCase() + ".h",
                            path: "include/",
                        },
                    },
                };
                return initResults;
            }
            else if (imp.interfaceId.name === "pin-standard") {
                return (_e = (_d = _this.model).getPCPHelper) === null || _e === void 0 ? void 0 : _e.call(_d).getData();
            }
            else if (imp.interfaceId.name === "interrupt-standard") {
                var interrupts_1 = [];
                var actions_1 = {};
                var isHighPriority_1 = (_h = (_g = (_f = _this.model) === null || _f === void 0 ? void 0 : _f.getImportValue("interrupt_standard")) === null || _g === void 0 ? void 0 : _g.isHighPriority) !== null && _h !== void 0 ? _h : {};
                (_l = (0, Utils_1.values)((_k = (_j = _this.model.getHardware()) === null || _j === void 0 ? void 0 : _j.getPeripheral().interrupts) !== null && _k !== void 0 ? _k : {})) === null || _l === void 0 ? void 0 : _l.forEach(function (interrupt) {
                    var _a, _b;
                    var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
                    if (!interrupt)
                        return;
                    var filterInterrupt = (_e = (_d = (_c = _this.model
                        .getDerivedFunctions()).filterInterrupts) === null || _d === void 0 ? void 0 : _d.call(_c, interrupt.name)) !== null && _e !== void 0 ? _e : true;
                    if (filterInterrupt) {
                        var interruptComponentName = (_g = (_f = _this.getInterruptComponentName(interrupt.name)) !== null && _f !== void 0 ? _f : interrupt.name.toLowerCase()) !== null && _g !== void 0 ? _g : "";
                        var isEnabled_1 = (_h = _this.model.isComponentValue(interruptComponentName !== null && interruptComponentName !== void 0 ? interruptComponentName : "")) !== null && _h !== void 0 ? _h : false;
                        interrupts_1.push({
                            //Standard
                            name: (_j = interrupt.name) !== null && _j !== void 0 ? _j : "",
                            module: (_m = (_l = (_k = _this.model.getHardware()) === null || _k === void 0 ? void 0 : _k.getName()) !== null && _l !== void 0 ? _l : _this.model.getName()) !== null && _m !== void 0 ? _m : "",
                            isEnabled: isEnabled_1,
                            //Callback Extension
                            isrCallback: (_r = (_q = (_o = _this.model) === null || _o === void 0 ? void 0 : (_p = _o.getDerivedFunctions()).isrCallback) === null || _q === void 0 ? void 0 : _q.call(_p, interrupt.name)) !== null && _r !== void 0 ? _r : {
                                name: _this.model.getName() + interrupt.handlerName,
                                header: (_v = (_u = (_s = _this.model) === null || _s === void 0 ? void 0 : (_t = _s.getDerivedFunctions()).headerFile) === null || _u === void 0 ? void 0 : _u.call(_t)) !== null && _v !== void 0 ? _v : {
                                    name: _this.model.getName().toLowerCase() + ".h",
                                    path: "include/",
                                },
                            },
                            generateISR: isEnabled_1,
                            //Priority Extension
                            isHighPriority: (_w = isHighPriority_1[interrupt.name]) !== null && _w !== void 0 ? _w : true,
                        });
                        var isEnableActions = (_a = ((_z = (_y = (_x = _this.model
                            .getDerivedFunctions()).getInterruptActions) === null || _y === void 0 ? void 0 : _y.call(_x, interrupt.name, "isEnabled")) !== null && _z !== void 0 ? _z : [])).concat.apply(_a, (0, InterruptActions_1.getDefaultInterruptActions)(_this.model, interruptComponentName));
                        var isEnableAction = (0, Arrays_1.find)(isEnableActions, function (action) { return action["validFor"] !== isEnabled_1; });
                        actions_1 = __assign(__assign({}, actions_1), (_b = {}, _b[interrupt.name] = __assign(__assign({}, actions_1 === null || actions_1 === void 0 ? void 0 : actions_1[interrupt.name]), { isEnabled: isEnableAction ? [isEnableAction] : [] }), _b));
                    }
                });
                return {
                    interruptList: interrupts_1,
                    interruptActions: actions_1,
                    moduleName: (_m = _this.model.getName()) !== null && _m !== void 0 ? _m : "",
                };
            }
            else if (imp.interfaceId.name === "api-prefix-registration") {
                var apiPrefixResults = {
                    apiPrefix: (_q = (_p = (_o = _this.model) === null || _o === void 0 ? void 0 : _o.getDerivedFunctions()) === null || _p === void 0 ? void 0 : _p.apiPrefix) !== null && _q !== void 0 ? _q : (_r = _this.model) === null || _r === void 0 ? void 0 : _r.getComponentValue("componentName"),
                    moduleName: (_s = _this.model) === null || _s === void 0 ? void 0 : _s.getName(),
                };
                return apiPrefixResults;
            }
        };
        this.getInterruptComponentName = function (interruptName) {
            var _a, _b;
            return (_b = (_a = _this.model.getDerivedFunctions()) === null || _a === void 0 ? void 0 : _a.interruptComponentName) === null || _b === void 0 ? void 0 : _b.call(_a, interruptName);
        };
        this.imports = imports;
        this.model = model;
    }
    return MyImportInterfaces;
}());
exports.MyImportInterfaces = MyImportInterfaces;
//# sourceMappingURL=imports.js.map